import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  size?: 'normal' | 'large';
  onClick?: () => void;
}
export function CTAButton({
  children,
  className = '',
  size = 'normal',
  onClick
}: CTAButtonProps) {
  const sizeClasses = size === 'large' ? 'text-xl py-5 px-6 md:px-12' : 'text-lg py-4 px-6 md:px-10';
  return <button onClick={onClick} className={`
        bg-cta-red text-white font-bold uppercase rounded-full
        animate-pulse-cta hover:brightness-110 transition-all duration-300
        w-full md:w-auto text-center shadow-[0_0_20px_rgba(204,0,0,0.6)]
        ${sizeClasses} ${className}
      `} data-id="element-20">
      {children}
    </button>;
}